import { delegate } from '../utils/delegate.js';

/**
 * If the user is already present, we don't want them to add their password on the form to prevent confusion.
 */

delegate({
  selector: '.user-exists',
  eventName: 'change',
  handler: async (e) => {
    const existingUserURL = e.target.dataset.existingUserCheck + encodeURIComponent(e.target.value);

    // there could be non-existing elements, so we filter them out with .filter(n => n)
    const containers = [
      document.querySelector(e.target.dataset.passwordConfirmationContainer),
      document.querySelector(e.target.dataset.nameContainer),
      document.querySelector(e.target.dataset.termsOfServiceContainer),
      document.querySelector(e.target.dataset.marketingOptInContainer)
    ].filter(n => n);

    // there could be non-existing elements, so we filter them out with .filter(n => n)
    const inputs = [
      document.querySelector('#user_first_name'),
      document.querySelector('#user_last_name'),
      document.querySelector('#user_password_confirmation'),
      document.querySelector('#user_terms_of_service'),
      document.querySelector('#user_opt_outs_list')
    ].filter(n => n);

    const formHeading = document.querySelector(e.target.dataset.formHeading);
    const formSubmitButton = document.querySelector(e.target.dataset.formSubmitButton);

    const response = await fetch(existingUserURL);
    const json = await response.json();

    if (json.user_exists === true) {
      containers.forEach(element => { element.classList.add('user-exists') })
      inputs.forEach( element => element.required = false )

      formHeading.innerHTML = "Sign in to your account"
      formSubmitButton.value = "Sign in"
    } else {
      containers.forEach( element => element.classList.remove('user-exists') )
      inputs.forEach( element => element.required = true )

      formHeading.innerHTML = "Create an account"
      formSubmitButton.value = "Create an account"
    }
  }
})
